import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { upgradeMembershipImage } from 'src/app/models/placeholder';

@Component({
  selector: 'app-upgrade-membership',
  templateUrl: './upgrade-membership.component.html',
  styleUrls: ['./upgrade-membership.component.scss'],
})
export class UpgradeMembershipComponent implements OnInit {
  @Input() message: string;
  @Input() message2: string;
  image: string;

  constructor(private translate: TranslateService) {
    this.image = upgradeMembershipImage;

    if (!this.message) {
      this.translate
        .get('upgrade_membership_cmp.upgrade_membership_title')
        .subscribe((res: string) => {
          this.message = res;
        });
    }

    if (!this.message2) {
      this.translate
        .get('upgrade_membership_cmp.upgrade_membership_subtitle')
        .subscribe((res: string) => {
          this.message2 = res;
        });
    }
  }

  ngOnInit() {}
}
